import { DeliveryMethod } from "./DeliveryMethod";
import EConomicData from "./EConomicData";

export default class Store {
	id: string;
	name: string;
	cvr: string;
	phoneNumber: string;
	email: string;
	address: string;
	postalCode: string;
	city: string;
	country: string;
	productionFacilityId: string;
	deliveryMethod: DeliveryMethod;
	eConomicData: EConomicData;
	isDomainStore: boolean;
	priceDifferencePercent: number;

	constructor() {
		this.name = "";
		this.cvr = "";
		this.phoneNumber = "";
		this.email = "";
		this.address = "";
		this.postalCode = "";
		this.city = "";
		this.country = "";
		this.productionFacilityId = "";
		this.priceDifferencePercent = 0;
	}

	public isEqual(store: Store): boolean {
		return store.name === this.name &&
			store.cvr === this.cvr &&
			store.phoneNumber === this.phoneNumber &&
			store.email === this.email &&
			store.address === this.address &&
			store.city === this.city &&
			store.country === this.country &&
			store.postalCode === this.postalCode &&
			store.productionFacilityId === this.productionFacilityId &&
			store.deliveryMethod === this.deliveryMethod &&
			store.isDomainStore === this.isDomainStore &&
			store.priceDifferencePercent === this.priceDifferencePercent &&
			(!store.eConomicData || this.eConomicData.isEqual(store.eConomicData));
	}
}
